(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/teams/assets/javascripts/create-team-container.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/teams/assets/javascripts/create-team-container.js');
"use strict";

const {
  ReactButton: Button,
  ReactPaper: Paper
} = svs.ui;
const CreateTeamContainer = _ref => {
  let {
    onClick = []
  } = _ref;
  return React.createElement(Paper, {
    branding: "sport",
    className: "create-team-container-holder"
  }, React.createElement("div", {
    className: "create-team-container"
  }, React.createElement("div", null, "Bjud in dina v\xE4nner", React.createElement("br", null), "eller kollegor!"), React.createElement(Button, {
    className: "qa-init-create-team",
    inverted: true,
    onClick: onClick
  }, "Skapa lag")));
};
setGlobal('svs.components.marketplaceCompetition.teams.CreateTeamContainer', CreateTeamContainer);

 })(window);